module.exports = __webpack_public_path__ + "static/media/companylogo.dddd5efa.jpg";